import { render, staticRenderFns } from "./SearchMessage.vue?vue&type=template&id=40c67392&scoped=true&"
import script from "./SearchMessage.vue?vue&type=script&lang=js&"
export * from "./SearchMessage.vue?vue&type=script&lang=js&"
import style0 from "./SearchMessage.vue?vue&type=style&index=0&id=40c67392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c67392",
  null
  
)

export default component.exports